import { Environment } from './env.interface';

export const environment: Environment = {
  env: 'punksv1-mainnet',
  mocked: false,
  production: true,
  enableLocalMimic: false,
  collection: 'cryptopunks-v1',
  collectionTitle: 'CryptoPunks V1',
  myBidsMinEth: 1,
  filteredTokenFromBids: [],
  tokenName: 'Punk V1',
  chainId: 1,
  // graphURI: 'https://gateway-arbitrum.network.thegraph.com/api/21d4166cc91220f9a260c3ef553b8862/subgraphs/id/DqpeCo1S6eyHx6uohQqfYLcLqTX6PSzxuvxza7Jo4SR',
  auctionHouseUri: 'https://gateway-arbitrum.network.thegraph.com/api/21d4166cc91220f9a260c3ef553b8862/subgraphs/id/CDkJ2KXjaMEtt91EWsnH3aVYgWYf9usVPYCspnmexGdj',
  flashLoanContractAddress: '0x7c0aa1d7ba0d704bb43cea7df9c219e1a6c24b2f',
  // graphURI: 'https://api.studio.thegraph.com/query/16172/nll-eth-limo/v0.0.7',
  // graphURI: 'https://api.studio.thegraph.com/query/16172/punks-v-1/version/latest',
  // graphURI: 'https://gateway.thegraph.com/api/21d4166cc91220f9a260c3ef553b8862/subgraphs/id/2TLKbEwQztSqXi47LVbUFHiyyH78xPZcvAYvcwfgai6w',
  //graphURI: 'https://gateway.thegraph.com/api/21d4166cc91220f9a260c3ef553b8862/subgraphs/id/2TLKbEwQztSqXi47LVbUFHiyyH78xPZcvAYvcwfgai6w',
  //graphURI: 'https://gateway.thegraph.com/api/21d4166cc91220f9a260c3ef553b8862/deployments/id/QmPyLtKqmyYQtEcQdQJKF9SsUwqtSttCnCVtt9ggBqnqhw',
  graphURI: 'https://gateway.thegraph.com/api/21d4166cc91220f9a260c3ef553b8862/deployments/id/QmXoMPJj8r6rNmdcntKeWpEYyHJQgse33bjqSBySLfBarE',
  statesGraphURI: 'https://gateway.thegraph.com/api/21d4166cc91220f9a260c3ef553b8862/deployments/id/QmXoMPJj8r6rNmdcntKeWpEYyHJQgse33bjqSBySLfBarE',
  nftxGraphURI: 'https://gateway-arbitrum.network.thegraph.com/api/21d4166cc91220f9a260c3ef553b8862/subgraphs/id/Epp6gJotEJKAsJYdk7bDEURtGWWeZVXwZds2Pgw8eG51',
  cigGraphURI: 'https://api.studio.thegraph.com/query/4302/cig-token/version/latest',
  v1PunksMarketAddress: '0x6ba6f2207e343923ba692e5cae646fb0f566db8d',
  unwrapV1PunksAddress: '0x6D263B22D1b2fEb93881AF6ff57666EfA5A8F346',
  punksmarketV1RouterAddress: '0x64e507febf26521b73fbdfa533106b2042533218',
  punksmarketBidIndexerUrl: 'https://indexer.punksmarket.app',
  // graphURI: 'https://api.studio.thegraph.com/query/4302/cryptopunks_eth/version/latest',
  // graphURI: 'http://localhost:8000/subgraphs/name/cryptopunks_eth',
  // staticUrl: 'http://10.0.0.53:3001',
  staticUrl: 'https://punkcdn.com/data',
  staticDownloadUrl: 'https://punkcdn.com/data/images/punk',
  tokenImagePath: '/images/punk',
  punksMarketAddress: '0x759c6C1923910930C18ef490B3c3DbeFf24003cE',
  wrappedPunksAddress: '0x282bdd42f4eb70e7a9d9f40c8fea0825b7f68c5d', // or any erc721 contract
  stashFactoryAddress: '0x25d136deEBE7C07C2B9A933924aB4BA419027F37',
  
  unsettledBlocks: 7200, // 7200 = 24 hours
  auctionMaxBlocks: 2400, // 2400 = 8 hours
  extendedBlocks: 25, // 25 = 5min
  blockTimeInSec: 12.08,
  auctionStarterValue: 25000,
  lastUsdPrice: 1684627000,
  auctionStarterAddress: '0xA8330c66F01239Af34b7F12bDf159A0Aed982514'.toLowerCase(),
  cigAddress: '0xCB56b52316041A62B6b5D0583DcE4A8AE7a3C629',
  nftxVaultAddress: '0xb39185e33e8c28e0bb3dbbce24da5dea6379ae91',
  punkDataAddress: '0x16f5a35647d6f03d5d3da7b35409d65ba03af3b2',
  c721Address: '0x0000000000000000000000000000000000000000',
  // rpcHttpProvider: 'http://geth.dappnode:8545',
  rpcHttpProvider: 'https://eth-mainnet.g.alchemy.com/v2/Avlo0U7gIF-fbaub34_uQO3DzxNtCP4Y',
  alchemyApiKey: 'Avlo0U7gIF-fbaub34_uQO3DzxNtCP4Y',
  simpleHashAPIKey: 'sh_sk1_Z4jhWXXBE09em',
  simpleHashCollectionId: '4b65507dbf1bd3d089cbbc11a0838e47', // TODO: Update with correct CryptoPunks V1 collection ID
  siteUrl: 'https://backend.v1cryptopunks.com',
  marketplaceUrl: 'https://v1cryptopunks.com',
  marketplaceName: 'V1Cryptopunks.com',
  notifications: {
    // apiUrl: 'https://phunks.auction/api',
    apiUrl: 'https://xbot.v1cryptopunks.com',
    vapidKey: 'BJ3ErYtRt0hi0Kfb54drJ5a4iZ_77w6x97JqysloDqktn7ZZ55agEj_wdw7tdzCtEP-soVGQ15PY15-H5jdlXc0',
  },
  flaggedTransactions: [
    "0xa4fa9c0976e550a27184c1ffd17f55f770c9afa429b7cd8495004302a82722c5".toLowerCase(),
    "0x92488a00dfa0746c300c66a716e6cc11ba9c0f9d40d8c58e792cc7fcebf432d0".toLowerCase(),
  ],
  gondiEnabled: true,
  gondiUrl: 'https://gondiproxy.nfthost.org/lending/graphql', 
  alternativeListingsGraphURI: 'https://listing-indexer.nfthost.org/graphql', // Alternative endpoint for feature flipping
  featureFlags: {

    NEW_GRAPH_FOR_TX_HISTORY: true, // Feature flag to use new GraphQL service for tx history
    NEW_GRAPH_FOR_SALE_HISTORY: true, // Use alternative provider for sales history
    NEW_GRAPH_FOR_LARGEST_SALES: true, // true = overview largest sales from nft-indexer GET /events/sales/largest
    USE_ALTERNATIVE_LISTINGS_API: true, // Enable alternative API for testing
    USE_CUSTOM_NFTX_SCRAPER: true, // Enable custom NFTX scraper for price
    NEW_ERC20_PAIR_DATASOURCE: true, // Use Alchemy Prices API for token pair prices
    USE_OUR_SALES_INDEXER_FOR_OWNERSHIP: true, // Use alternative REST endpoint for ownership data
    USE_OUR_SALES_INDEXER__FOR_DASHBOARD_DATA: true, // Use alternative GraphQL service for dashboard sales data
    PUNKSMARKET_NATIVE_TRADING: true, // List/buy/delist unwrapped V1 punks in-app via PunksMarket router
    PUNKSMARKET_BID_SUPPORT: true, // PunksMarket on-chain bids (indexer)
    PUNKSMARKET_BID_NATIVE: true, // placeBid / acceptBid / cancelBid in-app
    STASH_BID_SUPPORT: false, // Feature flag to show/hide stash bid functionality
    STASH_BID_PROTECTION: false, // Stash bid legacy protection (listings-scraper: ENABLE_STASH_BID_PROTECTION)
    NEW_NOTIFICATION_SYSTEM: false, // true = /notifications page, false = PWA push
    CROSS_MARKETPLACE_COUNTERPART: true, // Enable cross-marketplace counterpart (sibling pairing, cross-collection events)
  },
  alternativeGraphURI: 'https://sales-indexer.nfthost.org/graphql', // Alternative endpoint for feature flipping
  debugMode: false, // Debug mode disabled by default in production
  cigCEOAddress: '0x282bdd42f4eb70e7a9d9f40c8fea0825b7f68c5d', // CEO address for CIG protocol
  indexerStatusRegexp: '(.*)punksv1(.*)', // Filter for punksv1 indexers
  crossMarketplaceUrl: 'https://cryptopunks.eth.limo',
  v2PunksMarketAddress: '0xb47e3cd837ddf8e4c57f05d70ab865de6e193bbb',
  adminWallets: ['0x516fc698fb46506aa983a14f40b30c908d86dc82'],
  publicNotificationChannels: [
    {
      type: 'telegram',
      title: 'Telegram',
      subtitle: 'Marketplace notifications',
      description: 'Real-time sales, bids, and listings broadcast.',
      url: 'https://t.me/CryptoPunksEthBot',
    },
    {
      type: 'discord',
      title: 'Discord',
      subtitle: 'Marketplace community',
      description: 'Marketplace announcements and community updates.',
      url: 'https://discord.com/invite/A9cv4wwVQd',
    },
    {
      type: 'x',
      title: 'X',
      subtitle: 'Bot feed',
      description: 'Live social updates from the marketplace bot.',
      url: 'https://x.com/punkbot_ce',
    },
  ],
  
  graphStatus: [
    {
      url: 'https://api.studio.thegraph.com/query/16172/punks-v-1/v0.0.132',
      description: 'N+2 graph',
      name: 'Beta',
      version: 'v0.0.132',
      changes: ['Fix for seaport 1.6 batch bug (do not divide by token count, use consideration data)']
    },
    {
      url: 'https://api.studio.thegraph.com/query/16172/punks-v-1/v0.0.131',
      description: 'N+1 graph',
      name: 'Beta',
      version: 'v0.0.131',
      changes: ['Bulk seaport 1.6 batch bugfix (0x96afc4a58a63...95b146323da1)']
    },
    {
      url: 'https://api.studio.thegraph.com/query/16172/punks-v-1/v0.0.130',
      description: 'Main production graph for V1 Punks',
      name: 'Production',
      version: 'v0.0.130',
      changes: ['Numerous fixes']
    },/*
    {
      url: 'https://gateway.thegraph.com/api/21d4166cc91220f9a260c3ef553b8862/deployments/id/QmR7MZV6e9UsH5nRfyEnsRXMLXTHet5SLi9oEmJm4cXUhC',
      description: 'Main production graph for V1 Punks',
      name: 'Production',
      version: 'v0.0.109',
      changes: ['Initial graph']
    },*/
  ]
};
